import { useTranslation } from 'react-i18next';

import { Content, ContentWrapper } from '../Content';
import { featuredMediaArticle, getData, sideMediaArticles } from './data';
import * as Styled from './HuddInMedia.styles';

const ArticleMeta = ({ date, source }) => (
  <Styled.Meta variant="body16">
    {date} • {source}
  </Styled.Meta>
);

const SideArticleCard = ({ article }) => {
  const content = (
    <>
      <Styled.SideImage src={article.image} alt={article.imageAlt} />

      <Styled.SideContent>
        <Styled.SideHead>
          <ArticleMeta date={article.date} source={article.source} />
          <Styled.SideTitle variant="h5">{article.title}</Styled.SideTitle>
        </Styled.SideHead>

        <Styled.SideText variant="body16">{article.text}</Styled.SideText>
      </Styled.SideContent>
    </>
  );

  if (!article.href) {
    return (
      <Styled.SideCardStatic className="glass-border">
        {content}
      </Styled.SideCardStatic>
    );
  }

  return (
    <Styled.SideCard
      className="glass-border"
      href={article.href}
      target="_blank"
      rel="noreferrer"
    >
      {content}
    </Styled.SideCard>
  );
};

const HuddInMedia = () => {
  const { t } = useTranslation();
  const { label, title } = getData(t);

  return (
    <Styled.Section id="hudd-in-media">
      <ContentWrapper>
        <Content labels={[label]} title={title} titleVariant="h2" />

        <Styled.Grid>
          <Styled.FeaturedCard
            className="glass-border"
            href={featuredMediaArticle.href}
            target="_blank"
            rel="noreferrer"
          >
            <Styled.FeaturedImage
              src={featuredMediaArticle.image}
              alt={featuredMediaArticle.imageAlt}
            />

            <Styled.FeaturedContent>
              <Styled.FeaturedHead>
                <ArticleMeta
                  date={featuredMediaArticle.date}
                  source={featuredMediaArticle.source}
                />

                <Styled.FeaturedTitle variant="h4">
                  {featuredMediaArticle.title}
                </Styled.FeaturedTitle>
              </Styled.FeaturedHead>

              <Styled.FeaturedText variant="body16">
                {featuredMediaArticle.text}
              </Styled.FeaturedText>
            </Styled.FeaturedContent>
          </Styled.FeaturedCard>

          <Styled.SideList>
            {sideMediaArticles.map((article) => (
              <SideArticleCard key={article.id} article={article} />
            ))}
          </Styled.SideList>
        </Styled.Grid>
      </ContentWrapper>
    </Styled.Section>
  );
};

export default HuddInMedia;
